// This file is auto-generated by generate-env.js. Do not edit manually.
import type { Environment } from './environment.model';
import { SUPPORTED_NETWORK } from './config';

export const environment: Environment = {
    ...{
    PROVIDERS: {
        bscTestnet: "https://bnb-testnet.g.alchemy.com/v2/XZWqSAyIyEq2xnnYDDdcQDlPr78D_tZA",
        sepolia: "https://eth-sepolia.g.alchemy.com/v2/XZWqSAyIyEq2xnnYDDdcQDlPr78D_tZA"
    },
    PROJECT_ID: "53b5566b92708732ca6761dc365ff889",
    CONTRACT_ADDRESS: "0xBb263843e8Ab685Cc4EcE99540A33fEAFB0F1834",
    PROJECT_URL: "https://dev-admin.aqualuxwellnessgroup.com/",
    PROJECT_NAME: "Aqualux",
    API_BASE_URL: "https://dev-api.aqualuxwellnessgroup.com/",
    production: false
},
    SUPPORTED_NETWORK,
};
